/** 船运单轨迹查询可用的业务时间字段。 */
export interface ShipTrackDatetimeSource {
    loadingTime?: string | null;
    startLoadingTime?: string | null;
    loadingCompletionTime?: string | null;
    departureTime?: string | null;
    arrivalTime?: string | null;
    unloadTime?: string | null;
    fallbackEndTime?: string | null;
}

/** 地图与轨迹弹窗共用的开始、结束时间。 */
export type ShipTrackDatetimeRange = [string, string];

/** 取第一个非空业务时间，保持船运单既有字段优先级。 */
const firstDatetime = (...values: Array<string | null | undefined>) => values.find(value => Boolean(value?.trim()))?.trim();

/**
 * 生成船舶 AIS 查询时间范围。
 * 无有效起止时间或结束时间早于开始时间时返回 undefined，避免发送残缺请求。
 */
export const createShipTrackDatetimeRange = (source: ShipTrackDatetimeSource): ShipTrackDatetimeRange | undefined => {
    const startTime = firstDatetime(
        source.loadingTime,
        source.startLoadingTime,
        source.loadingCompletionTime,
        source.departureTime
    );
    const endTime = firstDatetime(source.arrivalTime, source.unloadTime, source.fallbackEndTime);
    if (!startTime || !endTime) return undefined;

    const startTimestamp = new Date(startTime).getTime();
    const endTimestamp = new Date(endTime).getTime();
    if (!Number.isFinite(startTimestamp) || !Number.isFinite(endTimestamp) || startTimestamp > endTimestamp) return undefined;
    return [startTime, endTime];
};

/** 至少两个定位点才能绘制轨迹线；空数组或单点需要回退 AIS 数据源。 */
export const hasRenderableShipTrack = (trackList: unknown): trackList is unknown[] => Array.isArray(trackList) && trackList.length > 1;
